import AppIcon from "./AppIcon"
import CheckCircleIcon from "./CheckCircleIcon"
import CheckIcon from "./CheckIcon"
import CostIcon from "./CostIcon"
import HoursIcon from "./HoursIcon"
import InsuranceIcon from "./InsuranceIcon"
import PhoneIcon from "./PhoneIcon"
import LocationIcon from "./LocationIcon"

export {
  AppIcon,
  CheckCircleIcon,
  CheckIcon,
  CostIcon,
  HoursIcon,
  InsuranceIcon,
  PhoneIcon,
  LocationIcon,
}



// WEBPACK FOOTER //
// ./assets/common/components/icons/index.js